<template>

    <div class="products-list">

        <div class="content-top row">
            <div class="col-24 content-top__wrap">
                <div class="content-top__title-box">
                    <h1 class="content-top__heading">Aktywność użytkowników ProMarmite</h1>
                </div>

                <div class="content-top__search simple-search">
                    <input type="text" class="simple-search__input" @input="searchFiles()" placeholder="Wyszukaj..."
                        v-model="search">
                    <button class="simple-search__button" @click="getFiles()">
                        <icon icon="search" />
                    </button>
                </div>
            </div>
        </div>

        <div  class="content">

            <table class="items-table">

                <thead class="items-table__thead">

                    <tr class="items-table__tr">

                        <th class="items-table__th">
                            Użytkownik
                        </th>

                        <th class="items-table__th">
                            Data
                        </th>

                        <th class="items-table__th">
                            Ostatnia strona
                        </th>

                        <th class="items-table__th pr-0 text-right">
                            Akcje
                        </th>

                    </tr>

                </thead>
                <tbody class="items-table__tbody">

                    <template v-for="(userLog, key) in logs">
                        <tr class="items-table__tr" v-bind:key="key">

                            <td class="items-table__td">
                                <router-link class="items-table__router-link" :to="{name: 'wpUserActivityLog', params: {user: userLog.wp_user_id}}">
                                    {{userLog.wp_username}}
                                </router-link>
                            </td>

                            <td class="items-table__td">
                                <div class="form-box__mobile-element">Data operacji</div>
                                {{userLog.created_at | prettyDate(true) }}
                            </td>

                            <td class="items-table__td">
                                <div class="form-box__mobile-element">Ostatnia strona</div>
                                <span>{{userLog.wp_route}}</span>
                            </td>

                            <td class="items-table__td pr-0">
                                <div class="form-box__mobile-element">Akcje</div>
                                <div class="d-flex justify-content-end">
                                    <button class="button-icon" @click="showPreview(userLog)">
                                        <icon icon="preview"></icon>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>

        </div><!-- // Products list-->

        <!-- Pagination -->
        <!-- <pagination :pagination="logs" @paginate="getLogs()" :offset="1"></pagination> -->
        <!-- Pagination -->

        <!-- Modal delete -->
        <modal :show="showModal" size="lg" @close="showModal = !showModal">
            <div slot="header" class="notice-modal__header--title">
                Podgląd logu #{{ previewLog.id }}
            </div>

            <div slot="body">
                <div class="row" v-if="previewLog.preview">
                    <vue-json-pretty :showLength="true" :data="previewLog.preview" :highlightMouseoverNode="true"></vue-json-pretty>
                </div>
                <div v-else class="row">
                    <div class="col-24 col-xl-12" v-if="previewLog.old">
                        <span v-text="(previewLog.new) ? 'Przed:' : ''"></span>
                        <vue-json-pretty :showLength="true" :data="previewLog.old" :highlightMouseoverNode="true"></vue-json-pretty>
                    </div>
                    <div class="col-24 mt-5 mt-xl-0 col-xl-12" v-if="previewLog.new">
                        <span v-text="(previewLog.old) ? 'Po:' : ''"></span>
                        <vue-json-pretty :showLength="true" :data="previewLog.new" :highlightMouseoverNode="true"></vue-json-pretty>
                    </div>
                </div>
            </div>
        </modal>

    </div><!-- // Products -->

</template>

<script>
    import axios from 'axios';
    const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
    // import Pagination from './parts/Pagination';
    import Icon from './parts/Icon';
    import Modal from './parts/Modal';
    import VueJsonPretty from 'vue-json-pretty'
    import _ from 'lodash';


    export default {
        data() {
            return {
                search: '',
                logs: {},
                showModal: false,
                previewLog: {},
            }
        },
        components: {
            // Pagination,
            Icon,
            Modal,
            VueJsonPretty
        },
        async mounted() {
            await this.getLogs();
        },
        methods: {
            async getLogs() {
                try {
                    var params = {
                        'page': this.logs.current_page
                    };

                    if (this.search != '') params.search = this.search;

                    const response = await axios.get(API_BASE_URL + '/wp-users-logs', {
                        params: params
                    });

                    this.logs = response.data.data;

                } catch (error) {
                    this.$root.$emit('noticesBox', error.response.data);
                }
            },
            searchFiles: _.debounce(function () {
                // this.files.current_page = 1;
                this.getLogs()
            }, 400),
            showPreview(data) {
                let array = data;

                this.previewLog.id = data.id;
                this.previewLog.preview = array;

                this.showModal = true;
            }
        }
    }
</script>